import * as React from "react";
import { SVGProps } from "react";

const Optimism = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 453 453"
    {...props}
  >
    <circle cx={226.5} cy={226.5} r={226.5} fill="#FF0420" />
    <path
      fill="#fff"
      d="M165.821 286.66c-8.024-.166-15.107-2.047-21.25-5.644-6.087-3.653-10.929-8.882-14.526-15.689-3.542-6.862-5.589-14.72-6.143-23.574-.608-9.076.36-18.76 2.906-29.053 2.545-10.293 6.64-19.341 12.285-27.143 5.644-7.803 12.257-13.641 19.839-17.515 7.636-3.874 15.882-5.728 24.736-5.562 8.135.166 15.246 2.103 21.333 5.811 6.087 3.652 10.874 8.937 14.36 15.855 3.487 6.861 5.479 14.664 5.977 23.408.553 9.739-.498 19.756-3.154 30.049-2.657 10.293-6.779 19.202-12.369 26.728-5.589 7.526-12.146 13.171-19.672 16.934-7.471 3.763-15.578 5.561-24.322 5.395zm34.449-65.41.664-7.886c.553-9.85-.775-17.321-3.985-22.412-3.154-5.091-7.969-7.747-14.443-7.969-10.127-.332-18.179 4.151-24.155 13.448-5.922 9.297-9.27 22.301-10.044 39.013-.554 9.795.747 17.349 3.901 22.661 3.154 5.258 8.052 7.997 14.692 8.218 8.689.388 15.883-2.988 21.582-10.127 5.7-7.194 9.436-17.348 11.206-30.464l.582-4.482zm63.501 21.167L256.3 285h-24.321l21-120.859 42.334.083c13.06 0 23.326 3.624 30.796 10.874 7.471 7.249 10.736 16.712 9.795 28.388-.885 11.843-5.838 21.306-14.858 28.389-8.965 7.083-20.42 10.625-34.365 10.625l-22.91-.083zm3.403-20.171 20.254.166c6.53 0 11.953-1.688 16.269-5.063 4.317-3.376 6.89-7.941 7.72-13.697.83-5.755-.111-10.348-2.822-13.779-2.657-3.431-6.613-5.257-11.87-5.478l-22.911-.083-6.64 37.934z"
    />
  </svg>
);

export default Optimism;
